import { useMemo } from 'react';
import { useUserContext } from '../../context/UserContext';
import { calculateStudyParticipantDates } from '../../common/calculateStudyParticipantDates';
import { StudyParticipant } from '../../models/StudyParticipant';
import { ParticipantEventOccurrence } from '../../screens/study/helpers/ParticipantEventHelpers';

export function useHasActiveStudy() {
  const { studyParticipants, allOccurrences } = useUserContext();

  return useMemo(
    () => hasActiveStudy(studyParticipants ?? [], allOccurrences),
    [allOccurrences, studyParticipants]
  );
}

export const gActiveStudyParticipant = (
  studyParticipants: StudyParticipant[],
  allOccurrences: ParticipantEventOccurrence[]
) => {
  let studyParticipant;
  for (const studParticipant of studyParticipants || []) {
    const { study } = studParticipant;
    const dates = calculateStudyParticipantDates(study, studParticipant);
    if (!dates.isCompletedStudy && !studParticipant.paused) {
      studyParticipant = studParticipant;
      break;
    }
  }
  if (allOccurrences.length > 0) {
    return studyParticipant;
  } else {
    return undefined;
  }
};

export const hasActiveStudy = (
  studyParticipants: StudyParticipant[],
  allOccurrences: ParticipantEventOccurrence[]
) => {
  const studyParticipant = gActiveStudyParticipant(
    studyParticipants,
    allOccurrences
  );
  return studyParticipant && allOccurrences.length > 0;
};
